import component from "@wagich/svelte-tag";
import DepartmentDropdown from "./department-dropdown.svelte";

new component({
	component: DepartmentDropdown,
	tagname: "department-dropdown",
});
